// extracted by mini-css-extract-plugin
export default {"details":"nlWjs","actions":"Z0yHZ","actionButton":"_8Cge1","mobile":"L7000","leftActions":"kM4Nd","location":"tzXvs","infoText":"hwNrH"};